module.exports = __webpack_public_path__ + "img/outlet.ebca8af7.svg";